<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <h2 class="page-header__title">お申込み完了</h2>
    </div>
    <div id="page-content" class="page-content">
      <article>
        <section>
          <p>
            お客様のお申込みを受付致しました。<br />
            お申込確認メールをお送り致しますので、数時間経ってもメールの確認ができない場合は、
            <a href="mailto:training@bsac.jp">training@bsac.jp</a> までお問い合わせください。<br />
            またそのメールとは別にeラーニング受講サイトのURL、ログイン用のIDとパスワードを、本メールアドレスにお送り致しますので、そちらが届きましたら受講を開始してください。<br />
          </p>
          <div v-show="payBy === 'A'" class="page-content__creditcard-section">
            <p>クレジットカード決済を選択した方は下記ボタンをクリックしてください。</p>
            <p>
              <a :href="redirectUrl" class="btn btn-danger rounded-pill">
                クレジットカード決済へ進む
              </a>
            </p>
          </div>
          <div v-show="payBy === 'E'" class="page-content__creditcard-section">
            <p>コンビニ決済を選択した方は下記ボタンをクリックしてください。</p>
            <p>
              <a :href="redirectUrl" class="btn btn-danger rounded-pill">コンビニ決済へ進む</a>
            </p>
          </div>
          <div v-show="payBy === 'F'" class="page-content__creditcard-section">
            <p>PayPay決済を選択した方は下記ボタンをクリックしてください。</p>
            <p>
              <a :href="redirectUrl" class="btn btn-danger rounded-pill">PayPay決済へ進む</a>
            </p>
          </div>
          <h4 class="page-content__article-section-title--dialog-red">
            【注意事項】※かならずご確認ください。
          </h4>
          <div class="page-content__article-section-body--noindent">
            <ul>
              <li>
                <span class="page-content__ul--red">
                  迷惑メールフォルダにメールが届く可能性があります
                </span>
                ので、お手数ですがご確認をお願いします。
              </li>
              <li>
                受講サイトのメール送信は<span class="page-content__ul--red"
                  >土日祝祭日を挟む場合、翌営業日の対応</span
                >となり、お申込みが集中した場合は、送信にお時間を頂く場合がございます。また、連休やその前日の夕刻以降にお申込みをされた場合、送信までに日数がかかりますので、あらかじめご了承下さい。例えば、金曜日の19時にお申込み頂いても、受講を開始頂けるのは最短でも月曜日以降からとなります。
              </li>
              <li>
                受講期限は<span class="page-content__ul--red">6カ月</span
                >となりますので、くれぐれもご注意ください。
              </li>
              <li>
                事前振り込みの方は、本メール最後の【振込先口座】をご確認頂き、eラーニング受講料をお振込み下さい。<span
                  class="page-content__ul--red"
                  >ご入金確認後にメールを送信させて頂きます。</span
                >
              </li>
              <li>
                弊社よりURL、ID、パスワードのメールが届かない場合、誠にお手数をおかけしますが
                <a href="mailto:training@bsac.jp">training@bsac.jp</a>
                までご連絡を頂くか、代表電話番号　<a href="tel:03-5297-5656">03-5297-5656</a
                >までご連絡下さい。
              </li>
              <li>
                <span class="page-content__ul--red"
                  >健康チェックで所定の質問に回答があった場合、実技講習の受講前に医師の診断が必要となります。</span
                >医師の診断の後、コースの受講が認められない場合は、お客様のお申込みをお断りさせて頂きます。その場合、コース受講料を返金させて頂きますので、
                training@bsac.jp
                までその旨お申し出ください。また、医師の診断書の確認ができない場合、受講をお断りする場合がございますので、あらかじめご了承の程よろしくお願いいたします。
              </li>
            </ul>
          </div>
        </section>
      </article>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
              eラーニング申込トップ画面に戻る
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * 選択した支払方法を取得する
     */
    payBy: function () {
      if (this.$store.getters['elearningApplication/registerResponse'] === null) {
        return '';
      }
      return this.$store.getters['elearningApplication/registerResponse'].payBy;
    },
    /**
     * 取得したリダイレクトURLを取得する
     */
    redirectUrl: function () {
      if (this.$store.getters['elearningApplication/registerResponse'] === null) {
        return '';
      }
      return this.$store.getters['elearningApplication/registerResponse'].redirectUrl;
    },
  },
  destroyed() {
    // ストアに保存した内容をクリアする
    if (process.env.RAILS_ENV !== 'development') {
      this.$store.commit('elearningApplication/reset');
    }
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/page.scss';

.page-content__important-sentense {
  color: red;
  font-weight: bold;
}

.page-content__creditcard-section {
  margin: 1rem 1rem 1rem 1rem;
  padding: 1rem 1rem 1rem 1rem;
  text-align: center;
  border: solid 1px #7d7d7d;
}
</style>
